export default [
    '$rootScope',
    function deviceHasTouchEventsFacade($rootScope) {
        $rootScope.deviceHasTouchEvents = function deviceHasTouchEvents() {
            return window.Modernizr.touchevents;
        };
    }
];
